import { Component, OnInit } from '@angular/core';
import { NavegacionService } from '../sidenav.service';
import { User } from '../shared/user.model';
import { UserService } from '../shared/user.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  constructor(public userService: UserService ) { }
  public currentClient: User = null;

  ngOnInit() {
    this.userService.getUserClaims().subscribe((data: any) => {
      this.currentClient = data;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts